export default {
  valueType: "mobile",
  FormItemProps: {
    label: '手机号',
    rules: [
      {
        pattern: /^1(3[0-9]|4[01456879]|5[0-35-9]|6[2567]|7[0-8]|8[0-9]|9[0-35-9])\d{8}$/,
        message: '请输入正确的手机号',
      },
    ],
    style: {}
  },
  ControlWapperProps: {
    style: {
      display: "flex",
      maxWidth: "334px"
    }
  },
  ControlProps: {
    disabled: false,
    maxLength: 11,
    placeholder: "请输入",
    allowClear: true,
    style: {
      flex: 1
    }
  },
}

